import useAuthorityLevel from '@/hooks/useAuthorityLevel';
import React, { useEffect, useRef, useState } from 'react';
import YouTube from 'react-youtube';

export function CourseClassroomPlayerYoutube(props) {
  const { disclaimerModal, setFinishVideoModal, unansweredQuestions, videoId, intervalId, setIntervalId, onUpdateProgress, setUpdateContentNow, showQuizModal, setShowQuizModal, selectedItem, setCurrentQuiz } = props;
  const videoRef = useRef(null);
  const percent = useRef(null);
  const hasCompletedRef = useRef(false);
  const authorityLevel = useAuthorityLevel();
  const youtubeOpts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 0
    }
  };
  const [player, setPlayer] = useState(null);
  const [count, setCount] = useState(0);
  const [lastModalOpenTime, setLastModalOpenTime] = useState(0);

  useEffect(() => {
    if ((!showQuizModal || !disclaimerModal) && player) {
      player.playVideo();
    }
  }, [showQuizModal, disclaimerModal]);

  useEffect(() => {
    percent.current = null;
    hasCompletedRef.current = false;
  }, [videoId]);

  const parsedQuiz = selectedItem?.['quiz-items']?.map(item => {
    const time = item.duration;
    const parts = time.split(':');
    const hours = parseInt(parts[0], 10) * 3600;
    const minutes = parseInt(parts[1], 10) * 60;
    const seconds = parseInt(parts[2], 10);
    const totalSeconds = hours + minutes + seconds;
    return {
      body: item.body,
      id: item.id,
      duration: totalSeconds,
      'quiz-item-alternatives': item['quiz-item-alternatives'],
      taxonomies: item.taxonomies
    };
  });

  const openModalTimings = parsedQuiz?.map(item => item.duration);

  const onReady = e => {
    videoRef.current = e.target;
    setPlayer(e.target);
    callInterval(e);

    // tenta dar play automaticamente no carregamento inicial,
    // apenas se não houver quiz nem disclaimer abertos
    if (!showQuizModal && !disclaimerModal) {
      try {
        e.target.playVideo();
      } catch (err) {
        // navegadores podem bloquear autoplay sem interação
        console.warn('Não foi possível dar play automático no YouTube:', err);
      }
    }
  };

  const onPause = () => clearInterval(intervalId);

  const callInterval = event => {
    clearInterval(intervalId);
    setIntervalId(setInterval(() => checkProgress(), 100));
    if (event?.target?.getPlayerState() === 1) {
      setTimeout(() => setCount(0), 2000);
    }
  };

  const checkProgress = async () => {
    const e = videoRef.current;
    const videoCurrentTime = parseInt(e.getCurrentTime());
    const videoDuration = parseInt(e.getDuration());

    if (videoCurrentTime === videoDuration - 2 && unansweredQuestions.length > 0 && count === 0) {
      setFinishVideoModal(true);
      setShowQuizModal(true);
      setCurrentQuiz(unansweredQuestions[0]);
      player.pauseVideo();
      setCount(prevState => prevState + 1);
    }

    if (openModalTimings?.includes(Math.floor(videoCurrentTime))) {
      setCurrentQuiz(parsedQuiz?.find(item => item.duration == Math.floor(videoCurrentTime)));
      if (videoCurrentTime !== lastModalOpenTime) {
        setCount(count + 1);
        setShowQuizModal(true);
        player?.pauseVideo();

        if (document.fullscreenElement !== null) {
          document.exitFullscreen();
        }
        setLastModalOpenTime(videoCurrentTime);
      }
    }

    const percentage = parseFloat((videoCurrentTime * 100) / videoDuration).toFixed(2);

    if (authorityLevel === 'student') {
      const hasProgressChanged = percent.current !== percentage;
      const isAtEnd = videoDuration - videoCurrentTime <= 1; // <= 1s para acabar
      console.log('verificando progresso do aluno...', videoCurrentTime, videoDuration, hasProgressChanged, isAtEnd);

      if (!hasCompletedRef.current && hasProgressChanged && isAtEnd) {
        hasCompletedRef.current = true; // trava para executar o setUpdateContentNow apenas uma vez
        const parsedPercentage = percentage >= 80 ? 100 : percentage;
        await onUpdateProgress(parsedPercentage);
        setUpdateContentNow(true);
        clearInterval(intervalId);
      }

      if (isAtEnd) {
        clearInterval(intervalId);
      }
    }

    percent.current = percentage;
  };

  return (
    <YouTube
      videoId={videoId}
      opts={youtubeOpts}
      onReady={onReady}
      onPause={onPause}
      onPlay={callInterval}
      // onEnd={checkProgress}
      // onStateChange={callInterval}
    />
  );
}
